module.exports = __webpack_public_path__ + "img/createNewTask.2f25cd28.jpeg";